import { Currencies, useUtxCurrenciesGetAll } from '@utx/utx-client';
import BigNumber from 'bignumber.js';
import React, { createContext, useMemo } from 'react';
import { useStore } from 'store/store';

const DECIMAL_PERCENTAGE = 2;
const DEFAULT_DECIMALS = 8;

export const CurrenciesContext = createContext<{
  currencies?: Array<Currencies>;
  currenciesDict?: Record<Currencies['display_symbol'], Currencies>;
  loading: boolean;
  getDecimalByAsset: (asset: string) => number;
}>({
  currencies: [],
  currenciesDict: {},
  loading: false,
  getDecimalByAsset: (asset: string) => 0
});

export const CurrenciesContextProvider: React.FC = (props) => {
  const store = useStore();
  const { data, isLoading } = useUtxCurrenciesGetAll({
    axios: {
      headers: {
        Authorization: `Bearer ${store.authToken}`
      }
    },
    query: {
      queryKey: ['currencies'],
      enabled: true
    }
  });

  const { children } = props;
  const currenciesDict: Record<string, Currencies> = useMemo(() => {
    const currencies = data?.data;
    return (
      currencies?.reduce((res, currency) => {
        res[currency.display_symbol] = currency;
        return res;
      }, {} as Record<string, Currencies>) || {}
    );
  }, [data?.data]);

  const getDecimalByAsset = (asset: string) => {
    if (asset === '%') return DECIMAL_PERCENTAGE;
    return new BigNumber(currenciesDict?.[asset]?.display_decimal || DEFAULT_DECIMALS).toNumber();
  };

  return (
    <CurrenciesContext.Provider value={{ currencies: data?.data, currenciesDict, loading: isLoading, getDecimalByAsset }}>
      {children}
    </CurrenciesContext.Provider>
  );
};
